import * as React from 'react';
const GridEditIcon = ({ width = 16, height = 16, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M6.667 15.167H6C2.38 15.167.833 13.62.833 10V6C.833 2.38 2.38.833 6 .833h4c3.62 0 5.167 1.547 5.167 5.167v1.333c0 .274-.227.5-.5.5a.504.504 0 0 1-.5-.5V6c0-3.073-1.094-4.167-4.167-4.167H6C2.927 1.833 1.834 2.927 1.834 6v4c0 3.073 1.093 4.167 4.166 4.167h.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5'
      fill='currentColor'
    />
    <path
      d='M14.667 6.167H1.354a.504.504 0 0 1-.5-.5c0-.274.226-.5.5-.5h13.313c.273 0 .5.226.5.5 0 .273-.227.5-.5.5M8 10.833H1.354a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5H8c.274 0 .5.227.5.5 0 .274-.226.5-.5.5'
      fill='currentColor'
    />
    <path
      d='M5.673 15.16a.504.504 0 0 1-.5-.5V1.347c0-.274.227-.5.5-.5.274 0 .5.226.5.5V14.66a.5.5 0 0 1-.5.5m4.667-6.667a.504.504 0 0 1-.5-.5V1.347c0-.274.226-.5.5-.5.273 0 .5.226.5.5v6.646a.5.5 0 0 1-.5.5m-.5 6.674a1 1 0 0 1-.72-.287 1 1 0 0 1-.273-.887L9 12.933c.033-.253.187-.56.373-.746L12.14 9.42c.36-.36.713-.547 1.087-.587.46-.046.92.154 1.353.587s.633.887.587 1.353c-.034.374-.227.727-.587 1.087l-2.767 2.767c-.18.18-.487.333-.747.373l-1.053.153q-.092.012-.173.014m3.507-5.334h-.027q-.2.021-.48.3L10.073 12.9a.45.45 0 0 0-.086.18l-.154 1.06 1.087-.12a.6.6 0 0 0 .18-.087l2.767-2.766q.279-.28.3-.48.02-.23-.3-.547-.3-.309-.52-.307'
      fill='currentColor'
    />
    <path
      d='M13.827 12.407a.5.5 0 0 1-.133-.02c-1-.28-1.8-1.08-2.08-2.08a.496.496 0 0 1 .346-.614c.273-.073.54.08.613.347.187.667.72 1.2 1.387 1.387a.5.5 0 0 1-.133.98'
      fill='currentColor'
    />
  </svg>
);
export default GridEditIcon;
